export class StorageConstants {
  public static ACTIVE_COMPANY_ID = "active_company_id";
  public static STORAGE_VERSION_DATA = "storage_version";
  public static STORAGE_ACCESS_TOKEN = "access_token";
  public static STORAGE_REFRESH_TOKEN = "refresh_token";
  public static STORAGE_USER_DATA = "user_data";
}
